import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { ordersOperationalDashboardRouter } from './routing/ordersOperationalDashboardRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { ordersOperationalDashboardDashboardAccessControl } from './access-control/ordersOperationalDashboardDashboardAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'orders-operational-dashboard',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'orders-operational-dashboard-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [ordersOperationalDashboardRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'View and manage customer orders, track shipments, and handle adjustments',
          labelId: 'ordersOperationalDashboardDomain.nav.title',
          route: 'orders-operational-dashboard-dashboard-page',
          accessControl: ordersOperationalDashboardDashboardAccessControl,
          positionNavV3: 2,
          dividerBefore: true,
          inToolPermissions: [
            {
              slug: Permission.OrdersOperationalConnectPlatformView,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalConnectPlatformView,
            },
            {
              slug: Permission.OrdersOperationalDashboardCancelOrder,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardCancelOrder,
            },
            // Force-complete was previously omitted from inToolPermissions,
            // so PermissionAccordion never rendered a toggle for it. That
            // meant no role in any environment could be granted
            // `orders_operational_dashboard.force_complete` via the
            // role-management UI — the runtime gate in useMarkAsCompleteEnabled
            // would therefore always hide the "Confirm delivery" menu item,
            // regardless of the roulette flag state. (FUL-232 follow-up.)
            {
              slug: Permission.OrdersOperationalDashboardForceComplete,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardForceComplete,
            },
            {
              slug: Permission.OrdersOperationalDashboardAdjustOrder,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardAdjustOrder,
            },
            {
              slug: Permission.OrdersOperationalDashboardAdjustOrderBasketContext,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardAdjustOrderBasketContext,
            },
            {
              slug: Permission.OrdersOperationalDashboardCustomersView,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardCustomersView,
            },
            {
              slug: Permission.OrdersOperationalDashboardCustomersAppeasementsView,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardCustomersAppeasementsView,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
